import { AUTH_SERVER_URL } from '../../config';

export const LOGGING_OUT = 'copo-logging-out';
export const AUTH_GET_USER_DATA_URL = `${ AUTH_SERVER_URL }/v1/users:currentUserData`;
